import axios from "axios";
import { apiGet, apiPost } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";


export function getOrganizationStats() {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.organizations.organizationStats());
            dispatch({
                type: 'ORGANIZATION_STATS_SUCCESS',
                payload: response.data
            })
        } catch(error) {
            console.log(error);
        }
    }
}

export function getOrganizationList (url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.organizations.organizationList()+url);
            dispatch({
                type: 'ORGANIZATION_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error);
        }
    };
}

export function getUsersList (url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.users.usersList()+url);
            dispatch({
                type: 'USERS_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error);
        }
    }
}

export function getUsersListByOrganization (url, type) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.users.usersList()+url);
            if(type === "list") {
                dispatch({
                    type: 'USERS_LIST_BY_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ASSIGNED_USERS_LIST_BY_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            }
            
        } catch (error) {
            console.log(error)
        }
    }
}

export function addOrganization (obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.organizations.addOrganization(), obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'ADD_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ADD_ORGANIZATION_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetAddOrganizationResponse() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ADD_ORGANIZATION_RESPNSE"
        })
    }
}

export function getOrganizationDetails(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.organizations.organizationDetails(), obj)
            dispatch({
                type: 'ORGANIZATION_DETAILS_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function getDomainList(url="", cancelToken) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.domains.domainList()+url, false, "json", cancelToken)
            dispatch({
                type: 'DOMAIN_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log("Request cancelled:", error.message);
            } else {
                console.error("Error in getDomainList:", error);
            }
        }
    }
}

export function resetDomainListResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_DOMAIN_LIST_RESPONSE'
        })
    }
}

export function getDomainListByOrganization(url, type) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.domains.domainList()+url)
            if(type === "list") {
                dispatch({
                    type: 'DOMAIN_LIST_BY_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'MODIFY_DOMAIN_LIST_BY_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            }
            
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetOrganizationDetail() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_ORGANIZATION_DETAILS'
        })
    }
}

export function resetUpdateOrganizationDetail() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_UPDATE_ORGANIZATION_DETAIL'
        })
    }
}

export function updateOrganizationDetail(obj) {
    return async (dispatch)=>{
        try {
            const response = await apiPost(apiEndpoints.organizations.updateOrganizationDetail(), obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'UPDATE_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'UPDATE_ORGANIZATION_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetUpdateOrganizationResponse() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_UPDATE_ORGANIZATION_RESPONSE'
        })
    }
}

export function deleteOrganization(obj) {
    return async (dispatch) => {
        try {
            const response = await apiPost(apiEndpoints.organizations.deleteOrganization(), obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'DELETE_ORGANIZATION_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DELETE_ORGANIZATION_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetDeleteOrganizationResponse() {
    return (dispatch) =>{
        dispatch({
            type: 'RESET_DELETE_ORGANIZATION_RESPONSE'
        })
    }
}

export function resetOrganizationListResponse () {
    return (dispatch) => {
        dispatch ({
            type: 'RESET_ORGANIZATION_LIST'
        })
    }
}

export function addDomain(obj) {
    return async (dispatch)=>{
        try {
            const response = await apiPost(apiEndpoints.domains.addDoamin(), obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'ADD_DOMAIN_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ADD_DOMAIN_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error){
            console.log(error)
        }
    }
}

export function resetAddDomainResponse() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_ADD_DOMAIN_RESPONSE'
        })
    }
}

export function resetDomainList() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_DOMAIN_LIST'
        })
    }
}

export function resetUsersList() {
    return (dispatch)=>{
        dispatch({
            type: 'RESET_USERS_LIST'
        })
    }
}

export function resetAssignUnassignResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_ASSIGN_UNASSIGN_RESPONSE'
        })
    }
}

export function assignAndUnAssign(url, obj) {
    return async (dispatch)=>{
        try {
            const response = await apiPost(url, obj)
            if(response?.data?.detail?.status === "success") {
                dispatch({
                    type: 'ASSIGN_UNASSIGN_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'ASSIGN_UNASSIGN_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}